import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import * as AOS from 'aos'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Public';
  showHeaderFooter = true;
  constructor(private router: Router){

  }
  ngOnInit() {
    AOS.init();
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
          return;
      }

      if(event.url.indexOf('campaign') > -1){
        this.showHeaderFooter = false;
      }
      else{
        this.showHeaderFooter = true;
      }

      window.scrollTo(0, 0);
      AOS.init();
      var navbarEl = document.querySelector('.w-nav-overlay') as HTMLElement;
      console.log(navbarEl);
      navbarEl.style.display = 'none';
      var navbarButtonEls = document.querySelectorAll('.w--open');
      navbarButtonEls.forEach(function (value) {
        var ele = value as HTMLElement;
        ele.classList.remove('w--open');
      }); 
    });
  }
}
